import React, {Component} from "react";
import SliderItem from "./SliderItem";


class GraphicModal extends Component {

    constructor(props) {
        super(props);
        this.state = {

            withInfo : true,
            downLoad : true

        };

    }

    componentDidMount() {


        //this.props.allGalleryDataFromStore({type:"MY_UPLOADS"});

        console.log("this.props.galleryData.galleryItems");
        console.log(this.props.galleryDetails);
    }

    /*shouldComponentUpdate(nextProps, nextState){
        return this.props.galleryDetails != nextProps.galleryDetails;
    }*/

    render() {

        let items = this.props.galItems;
        return (
            <div className="modal fade show gallery-modal" id="galleryModal" style={{display:"block"}}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close md-close" data-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">

                            <div className="gallery-modal-wrapper">
                                <div id="carouselExampleIndicators" className="carousel slide gallery-modal"
                            data-ride="carousel">
                                    <div className="carousel-inner">
                                        {items &&
                                        items.map((entry, index) =>
                                            <SliderItem item = {entry} iteration={index} />)
                                        }
                                    </div>
                                    <a className="carousel-control-prev" href="#carouselExampleIndicators"
                                       role="button" data-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carouselExampleIndicators"
                                       role="button" data-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                                {this.state.withInfo &&
                                <div className="gallery-option">
                                    <button className="file-info-gallery"></button>
                                </div>

                                }
                                {this.state.withInfo &&
                                <div className="info-toggler-block">

                                    <table className="table toggle-table">
                                        <tbody>
                                        <tr>
                                            <td>Image Size</td>
                                            <td align="right" className="inactive">1.45MB</td>
                                        </tr>
                                        <tr>
                                            <td>Dimensions</td>
                                            <td align="right" className="inactive">1200 X 768</td>
                                        </tr>
                                        <tr>
                                            <td>Type</td>
                                            <td align="right" className="inactive">JPG</td>
                                        </tr>
                                        <tr>
                                            <td>Uploaded By</td>
                                            <td align="right" className="inactive">John Doe</td>
                                        </tr>
                                        <tr>
                                            <td>Uploaded On</td>
                                            <td align="right" className="inactive">02/02/2018</td>
                                        </tr>
                                        <tr>
                                            <td>Downloads count</td>
                                            <td align="right" className="inactive">1452</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <div className="togller-inside-opt">
                                        {this.state.downLoad &&
                                        <button className="file-down-gallery"></button>
                                        }
                                        <button className="toggle-close"></button>
                                    </div>

                                </div>
                                }
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            );
        }

}




export default GraphicModal;



// WEBPACK FOOTER //
// ./src/components/gallery/GraphicModal.js